export function DashboardPage({ render }) {
  return render();
}
